import generateUtilityClasses from "../../utils/generateUtilityClasses/generateUtilityClasses.js";
import generateUtilityClass from "../../utils/generateUtilityClass/generateUtilityClass.js";
function getFormControlLabelUtilityClasses(slot) {
  return generateUtilityClass("MuiFormControlLabel", slot);
}
const formControlLabelClasses = generateUtilityClasses("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]);
export {
  formControlLabelClasses as default,
  getFormControlLabelUtilityClasses
};
//# sourceMappingURL=formControlLabelClasses.js.map
